import { isPerformActiveCoach } from "../utils/user-helpers";
import { getUserToRequest } from "../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";

function ensurePerformUpgrade({ res, locals }, next) {
  const { activeUser, organizationOwner } = locals;
  if (!activeUser) return next();

  const userToRequest = getUserToRequest(activeUser, organizationOwner);

  // Block PERFORM pages unless the (org owner's) perform billing is active or
  // past_due. Covers absent billing as well as unpaid/canceled.
  if (!isPerformActiveCoach(userToRequest)) {
    return res.redirect("/perform-billing");
  }

  return next();
}

export default ensurePerformUpgrade;
